import React from "react";

const DynamicAddFieldColumn = ({ dynamicField, data, handleChangeDynamicFields, handleChangeDynamicFieldValue }) => {
    return (
        <div>
            {" "}
            <div className="button-group pt-0 pb-2" style={{ margin: "initial" }}>
                <div className="form-group outer p-0 mb-0 col-md-12 align-items-center d-flex flex-wrap label-add-outer">
                    {dynamicField?.length > 0 &&
                        dynamicField?.map((item, index) => (
                            <div key={index} className="form-group d-flex align-items-center label-del col-md-3 pl-0 mb-0 mt-2 mr-3">
                                <div className="col-md-10 p-0">
                                    <input
                                        value={item}
                                        onChange={e => handleChangeDynamicFieldValue(data?.id, e.target.value, index)}
                                        className="form-control not-draggable"
                                        placeholder="Type Here..."
                                    />
                                </div>
                                <div className="col-md-2 p-0 pr-0">
                                    <button
                                        type="button"
                                        className="del-button not-draggable"
                                        onClick={() => {
                                            handleChangeDynamicFields(data?.id, "delete", index);
                                        }}
                                    >
                                        <i className="fas fa-trash" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    <button type="button" className="btn add-button-wrapper not-draggable" onClick={() => handleChangeDynamicFields(data?.id, "add")}>
                        + Add
                    </button>
                </div>
            </div>
        </div>
    );
};
export default DynamicAddFieldColumn;
